import * as React from 'react';

export const defaultSnackbarTimeout = 7000;

export const Snackbar = ({visible, text}: { visible: boolean, text: string, }) =>
  (<div className={`quill-snackbar ${visible ? 'visible' : ''}`} role="status">
    {visible ? text : null}
  </div>);
